module.exports = __webpack_public_path__ + "img/pcBanner1.6d50d0a5.jpg";